var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8999 22.8752C39.2434 22.2188 38.1792 22.2188 37.5228 22.8752L25.0583 35.3397C23.9994 36.3986 24.7494 38.2091 26.2468 38.2091H30.4776C30.4596 38.3077 30.4502 38.4092 30.4502 38.513V51.6737C30.4502 52.602 31.2028 53.3546 32.1311 53.3546H45.2918C46.2201 53.3546 46.9726 52.602 46.9726 51.6737V38.513C46.9726 38.4092 46.9632 38.3077 46.9452 38.2091H51.1758C52.6733 38.2091 53.4232 36.3986 52.3643 35.3397L39.8999 22.8752Z",
    fill: "#F57F20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5904,
    cy: 38.0905,
    r: 31.1064,
    stroke: "#F57F20",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/UpdateIcon.b9804d0f0c4c848f0d1253c54bf1c25f.svg";
export { ForwardRef as ReactComponent };